import { ArrowRight } from "lucide-react"

import { ActionDefinition } from "@/components/automations/types"

export const projectActions: ActionDefinition[] = [
  {
    key: "action__project_move_milestone",
    name: "Move to milestone",
    description: "Move the project to a specific milestone",
    category: "project",
    nodeType: "action",
    recordType: "project",
    icon: ArrowRight,
    requiresSubjects: ["project"],
    fields: [
      {
        key: "project_template_id",
        label: "Project template",
        inputType: "select",
        required: true,
        optionsSource: "project_templates",
      },
      {
        key: "project_milestone_id",
        label: "Milestone",
        inputType: "select",
        required: true,
        optionsSource: "project_milestones",
        parentField: "project_template_id",
      },
    ],
  },
]
